import { render } from "./ClaimCreatePage.vue?vue&type=template&id=3e1aa625"
import script from "./ClaimCreatePage.vue?vue&type=script&lang=js"
export * from "./ClaimCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__